import {Divider} from '@/components/ui/divider/Divider'
import {ProjectFormNewProjectSection} from '@/features/projects/components/project-form/project-form-new-project-section/ProjectFormNewProjectSection'
import {ProjectFormPatientSection} from '@/features/projects/components/project-form/project-form-patient-section/ProjectFormPatientSection'
import {ProjectFormReferenceSection} from '@/features/projects/components/project-form/project-form-reference-section/ProjectFormReferenceSection'
import {ProjectFormReferringSpecialistSection} from '@/features/projects/components/project-form/project-form-referring-specialist-section/ProjectFormReferringSpecialistSection'
import {ProjectExtended} from '@/features/projects/types'
import {useOutletContext} from 'react-router-dom'

export const ExtendsCycleProjectFormSections = ({isExtendable}: {isExtendable: boolean}) => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    return (
        <>
            <ProjectFormPatientSection showPatientSelect={false} patientId={project?.patientId} />
            <Divider direction="horizontal" />
            <ProjectFormReferenceSection isAllowed={isExtendable} editingOperation="renew" projectType="cyclic" />
            {isExtendable && (
                <>
                    <Divider direction="horizontal" />
                    <ProjectFormNewProjectSection editingOperation="renew" />
                    <Divider direction="horizontal" />
                    <ProjectFormReferringSpecialistSection />
                </>
            )}
        </>
    )
}
